module.exports = __webpack_public_path__ + "img/error.e36740b4.png";